import "core-js/modules/es.array.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";

var _dec, _class;

import { registerDecorator, ValidatorConstraint } from 'class-validator';
var IsOriginConstraint = (_dec = ValidatorConstraint(), _dec(_class = class IsOriginConstraint {
  validate(value) {
    try {
      var url = new URL(value);
      return url.origin === value;
    } catch (_unused) {}

    return false;
  }

}) || _class);
export function IsOrigin(validationOptions) {
  return function (object, propertyName) {
    registerDecorator({
      target: object.constructor,
      propertyName,
      options: validationOptions,
      constraints: [],
      validator: IsOriginConstraint
    });
  };
}